<div id="spin-group">
    <mat-spinner [diameter]="36" color="accent"> </mat-spinner>
    <!--  <div class="mat-body">
        Loading
    </div> -->
</div>
